export enum API_STATUS {
  FAILED = 'failed',
  IDLE = 'idle',
  LOADING = 'loading',
  COMPLETE = 'complete',
}
